// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/users';
import dataReducer from './slices/data';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import clientsReducer from './slices/clients';
import deploymentRequestsReducer from './slices/deployment-requests';
import trialRequestsReducer from './slices/trial-requests';
import analyticsReducer from './slices/analytics';
import deploymentGroupsReducer from './slices/deployment-groups';
import digitalUnitsReducer from './slices/digitalUnits';
import logsReducer from './slices/logs';
import backdropReducer from './slices/backdrop';
import synchronisationLogs from './slices/synchronisationLogs';
import emailTemplatesReducer from './slices/email-templates';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    data: persistReducer(
        {
            key: 'data',
            storage,
            keyPrefix: 'digital-robot-'
        },
        dataReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    users: userReducer,
    menu: menuReducer,
    clients: clientsReducer,
    deploymentRequests: deploymentRequestsReducer,
    trialRequests: trialRequestsReducer,
    analytics: analyticsReducer,
    deploymentGroups: deploymentGroupsReducer,
    digitalUnits: digitalUnitsReducer,
    logs: logsReducer,
    backdrop: backdropReducer,
    synchronisationLog: synchronisationLogs,
    emailTemplates: emailTemplatesReducer
});

export default reducer;
